// src/components/SessionManager.jsx
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { setLogoutCallback } from '../utils/axiosConfig';

const SessionManager = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setLogoutCallback(() => {
      sessionStorage.clear();
      localStorage.removeItem('token');
      navigate('/', { replace: true });
    });
  }, [navigate]);

  return null; // No UI
};

export default SessionManager;
